/**
 * Client instrumentation — Next.js runs this file in the browser before React
 * hydration, so before any consent-gated tag (GTM, GA4, the Salesforce beacon)
 * can exist.
 *
 * Email-link token (`?aqt=`): lift it out of the address bar into memory now, so
 * no tag, router state or form submission ever sees it. No-op unless
 * NEXT_PUBLIC_VISITOR_TOKEN is on. The token is only ever sent anywhere after the
 * visitor grants consent — see components/consent/useVisitorToken.ts.
 */
import { captureVisitorTokenFromUrl } from "@/lib/identity/capture";

captureVisitorTokenFromUrl();
